import { SVGProps } from 'react';

const AtSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8m-2-8a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    />
  </svg>
);
export default AtSign;
